<template>
  <v-dialog v-model="open" width="40%" @click:outside="cancel" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card class="main">
      <v-card-title class="primary white--text"
        ><v-toolbar-title>CHỌN MÃ HOÁ ĐƠN ĐÚNG</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <div class="ma-4">
        <div>Vui lòng chọn mã hoá đơn đúng</div>
        <v-radio-group class="mt-2" v-model="radioGroup">
          <v-radio v-for="code in listBillCode" :key="code" :label="code" :value="code"></v-radio>
        </v-radio-group>
      </div>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between">
        <v-btn @click="cancel" class="ma-2" outlined color="#0D47A1">Huỷ</v-btn>
        <v-btn :disabled="error" @click="accept" class="ma-2" color="#0D47A1" style="color:white">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import api from '@/plugins/api'
export default {
  props: {
    headers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      open: false,
      listBillCode: [],
      radioGroup: ''
    }
  },
  methods: {
    ...mapActions({
      fetchItems: 'importDeliveryProduct/fetchItems'
    }),
    async openDialog(importCheckId) {
      this.$loading.active = true
      const items = await api['ImportDeliveryProduct'].fetch({ importCheck: importCheckId })
      const listBillCode = this.uniqueBillCodes(items)
      this.listBillCode = listBillCode
      this.$loading.active = false
      this.open = true
    },
    cancel() {
      this.$emit('cancel')
      this.open = false
    },
    resetData() {
      this.items = []
      this.error = false
    },
    accept() {
      this.$emit('accept', this.radioGroup)
      this.open = false
    },
    uniqueBillCodes(inputArray) {
      const uniqueCodesSet = new Set()
      inputArray.forEach(obj => {
        if (obj.billCode) {
          uniqueCodesSet.add(obj.billCode)
        }
      })
      const uniqueCodesArray = Array.from(uniqueCodesSet)
      return uniqueCodesArray
    }
  }
}
</script>
<style scoped></style>
